import { PollResponseBase } from "abweb/dto/generated/async/PollResponseBase";
export class PollResponse extends PollResponseBase {
  static createPollResponse(numSubscriptions, responseStamp, responses, shutdown) {
    const retVal = new PollResponse();
    retVal.initPollResponse(numSubscriptions, responseStamp, responses, shutdown);
    return retVal;
  }
  constructor() {
    super();
  }
  initFromJson(json, deserializeContext) {
    super.initFromJson(json, deserializeContext);
    this.responses.forEach(response => {
      response.deserializeContext = deserializeContext;
    });
  }
}
//# sourceMappingURL=PollResponse.js.map
